// extracted by mini-css-extract-plugin
export default {"--sticky":"BackButtonLink_--sticky__SULiQ","link":"BackButtonLink_link__aXI9Y App_--rubber-fx__yYj6p"};